import React from 'react';
import { string, number, bool } from 'prop-types';
import classnames from 'classnames';
import useResultLengthLabel from './hooks/useResultLengthLabel';
import './ResultLength.scss';

function ResultLength({ nbHits, className, nbHitsPro, shouldShowProProducts }) {
    const rootClassnames = classnames('result-length-root', className);
    const text = useResultLengthLabel(nbHits, shouldShowProProducts, nbHitsPro);
    return (
        <div
            className={rootClassnames}
            data-qa="resultProductsNumberElm"
            data-results-count={nbHits}
        >
            {text}
        </div>
    );
}

ResultLength.propTypes = {
    className: string,
    nbHits: number,
    nbHitsPro: number,
    shouldShowProProducts: bool,
};

ResultLength.defaultProps = {
    className: null,
    nbHits: 0,
    nbHitsPro: 0,
    shouldShowProProducts: false,
};

export default ResultLength;
